(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsDeleteController',TabActionsDeleteController);

    TabActionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabActions'];

    function TabActionsDeleteController($uibModalInstance, entity, TabActions) {
        var vm = this;
        vm.tabActions = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabActions.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
